import { CommunityAnnouncements, Users } from '@platform/client';
import { HeaderFooterLayout } from '../../../app';
import { CommunityHomeBanner } from './CommunityHomeBanner';
import { CommunityHomeMobileBanner } from './CommunityHomeMobileBanner';
import { AdvisorCard } from './CommunitySidebar/AdvisorCard/AdvisorCard';
import { CommunityAnnouncementCard } from './CommunitySidebar/CommunityAnnouncementCard';
import { NetworkCard } from './CommunitySidebar/NetworkCard';
import { CommunityWinsCarousel } from './CommunityWinsCarousel/CommunityWinsCarousel';
import { EventsSegment } from './EventsSegment';
import { FundingOpportunitySegment } from './FundingOpportunitySegment';
import { JobPostingsSegment } from './JobOpeningsSegment';

export const CommunityHomePage = () => {
  const user = Users.useGetCurrentUser();

  const isRepresentative =
    user.isSuccess &&
    (user.data.role === 'representative' || user.data.role === 'representative_with_opportunity');

  const communityAnnouncements = CommunityAnnouncements.useGetCommunityAnnouncements({
    page: 0,
    limit: 1,
    type: isRepresentative ? 'organization' : 'professional',
  });

  return (
    <HeaderFooterLayout useDashboardHeader>
      <div className='max-w-[936px] block md:hidden'>
        <CommunityHomeMobileBanner />
      </div>
      <div className='max-w-[936px] hidden md:block'>
        <CommunityHomeBanner />
      </div>
      <div className='max-w-[936px] mt-4 md:mt-6 flex flex-col items-center md:items-stretch md:flex-row gap-4 md:gap-6'>
        <div className='w-[308px] py-4 md:order-last'>
          <div className='flex flex-col gap-4'>
            {communityAnnouncements.data?.length ?
              <CommunityAnnouncementCard
                title={communityAnnouncements.data[0].title}
                description={communityAnnouncements.data[0].description}
                callToAction={communityAnnouncements.data[0].callToAction}
                link={communityAnnouncements.data[0].link ?? undefined}
              />
            : undefined}
            <div className='hidden md:block'>
              <NetworkCard />
              {isRepresentative && <AdvisorCard />}
            </div>
          </div>
        </div>
        <div className='w-full md:flex-1 min-w-0 flex flex-col gap-6 pb-4'>
          <CommunityWinsCarousel />
          <EventsSegment />
          {!isRepresentative && <JobPostingsSegment />}
          {isRepresentative && <FundingOpportunitySegment />}
          <div className='md:hidden flex flex-col gap-6 items-center justify-center'>
            <NetworkCard />
            {isRepresentative && <AdvisorCard />}
          </div>
        </div>
      </div>
    </HeaderFooterLayout>
  );
};
